import { useEffect, useState } from 'react'
import { api } from '../../services/api'

function AuthFoodImage({ path }: { path?: string | null }) {
  const [src, setSrc] = useState('')
  useEffect(() => {
    if (!path) return undefined
    let url = ''
    let alive = true
    api.get(path, { responseType: 'blob' }).then((r) => {
      if (!alive) return
      url = URL.createObjectURL(r.data)
      setSrc(url)
    }).catch(() => {})
    return () => {
      alive = false
      if (url) URL.revokeObjectURL(url)
    }
  }, [path])
  if (!src) return null
  return <img src={src} alt="" className="w-20 h-20 object-cover rounded-xl" />
}

const empty = {
  restaurant: '',
  name: '',
  calories: '',
  protein: '',
  carbs: '',
  fat: '',
  portionQty: '1',
  portionUnit: 'g',
}

export default function LocalMealsAdmin() {
  const [rows, setRows] = useState<any[]>([])
  const [form, setForm] = useState<any>(empty)
  const [file, setFile] = useState<File | null>(null)
  const [editing, setEditing] = useState<string | null>(null)
  const [error, setError] = useState('')

  const load = () => api.get('/nutrition/local-meals').then((r) => setRows(r.data || [])).catch(() => setRows([]))
  useEffect(() => { load() }, [])

  const save = async () => {
    setError('')
    const data = new FormData()
    Object.entries(form).forEach(([key, value]) => data.append(key, String(value ?? '')))
    if (file) data.append('image', file)
    try {
      if (editing) await api.put(`/nutrition/local-meals/${editing}`, data)
      else await api.post('/nutrition/local-meals', data)
      setForm(empty)
      setFile(null)
      setEditing(null)
      await load()
    } catch (err: any) {
      setError(err?.response?.data?.message || 'No se pudo guardar')
    }
  }

  return (
    <div className="p-6 max-w-3xl mx-auto text-[#111827]">
      <h1 className="text-2xl font-bold mb-1">Comidas locales</h1>
      <p className="text-sm text-gray-500 mb-4">Foto del plato, restaurante, nombre y macros. El usuario la elige y se carga la porción.</p>
      <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-4 grid gap-2">
        <input className="border rounded-xl px-3 py-2" placeholder="Restaurante" value={form.restaurant} onChange={(e) => setForm({ ...form, restaurant: e.target.value })} />
        <input className="border rounded-xl px-3 py-2" placeholder="Nombre del plato" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <div className="grid grid-cols-2 gap-2">
          <input className="border rounded-xl px-3 py-2" placeholder="Calorías" value={form.calories} onChange={(e) => setForm({ ...form, calories: e.target.value })} />
          <input className="border rounded-xl px-3 py-2" placeholder="Proteína (g)" value={form.protein} onChange={(e) => setForm({ ...form, protein: e.target.value })} />
          <input className="border rounded-xl px-3 py-2" placeholder="Carbos (g)" value={form.carbs} onChange={(e) => setForm({ ...form, carbs: e.target.value })} />
          <input className="border rounded-xl px-3 py-2" placeholder="Grasa (g)" value={form.fat} onChange={(e) => setForm({ ...form, fat: e.target.value })} />
          <input className="border rounded-xl px-3 py-2" placeholder="Porción" value={form.portionQty} onChange={(e) => setForm({ ...form, portionQty: e.target.value })} />
          <input className="border rounded-xl px-3 py-2" placeholder="Medida (g, unidad)" value={form.portionUnit} onChange={(e) => setForm({ ...form, portionUnit: e.target.value })} />
        </div>
        <input type="file" accept="image/*" onChange={(e) => setFile(e.target.files?.[0] || null)} />
        {error ? <p className="text-sm text-red-600">{error}</p> : null}
        <button type="button" onClick={save} className="py-2 rounded-xl bg-[#64ba30] text-white font-semibold">{editing ? 'Guardar cambios' : 'Subir plato'}</button>
      </div>
      <div className="grid gap-3">
        {rows.map((row) => (
          <div key={row.id} className="bg-white border border-gray-200 rounded-2xl p-3 flex gap-3">
            <AuthFoodImage path={row.imageUrl} />
            <div className="flex-1">
              <p className="font-semibold">{row.name}</p>
              <p className="text-xs text-gray-500">{row.restaurant || 'Sin restaurante'} · {row.portionQty} {row.portionUnit}</p>
              <p className="text-sm">{Math.round(row.calories)} kcal · P {row.protein}g · C {row.carbs}g · G {row.fat}g</p>
              <button type="button" className="text-sm text-[#166534] mr-3" onClick={() => { setEditing(row.id); setForm({ restaurant: row.restaurant || '', name: row.name, calories: row.calories, protein: row.protein, carbs: row.carbs, fat: row.fat, portionQty: row.portionQty, portionUnit: row.portionUnit }) }}>Editar</button>
              <button type="button" className="text-sm text-red-600" onClick={async () => { await api.delete(`/nutrition/local-meals/${row.id}`); load() }}>Quitar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
